<template>
  <div style="overflow: hidden;width: 100%">
    <CommonHeader/>
    <div class="container" style="min-height: calc(100vh - 56px - 88px);">
      <a-row>
        <a-col class="mt-3 mb-3" :span="24">
          <a-breadcrumb>
            <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
            <a-breadcrumb-item>公告</a-breadcrumb-item>
          </a-breadcrumb>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="18">
          <a-card>
            <div class="p_text_bg">
              <div class="text-header">
                <h3 class="size6 mb-7" style="font-size: 24px;">{{ announce.announceName }}</h3>
                <br>
                <div class="d-flex justify-content-between" style="font-size: 14px;color: #8c8c8c;">
                  <span>项目编号: &nbsp;&nbsp;{{ announce.projectCode }}</span>
                  <span class="border-left">发布时间:&nbsp;&nbsp;{{ announce.publishTime }}</span>
                </div>
              </div>
              <div class="mt-6">
                <div>
                  <div class="announce-content" v-html="announce.announceContent">
                  </div>
                  <div style="text-align: center" v-if="announce.onlineSign && announce.onlineSign === '1'">
                    <a v-if="!isSign" href="javascript:;">报名后可以下载</a>
                    <upload-selector v-else ref="up1" :referId='announce.projectId' readonly="readonly"
                                     configKey='tender_file'/>
                    <upload-selector ref="up2" :referId='announce.announceId' readonly="readonly"
                                     configKey='common_tender_file'/>
                  </div>
                  <div style="text-align: center" v-else >
                  <upload-selector ref="up3" :referId='announce.projectId' readonly="readonly"
                                   configKey='tender_file'/>
                  </div>
                </div>

              </div>
            </div>
          </a-card>

        </a-col>
        <a-col :span="6">
          <a-card class="text-center">
            <div>
              <svg class="icon d-block" aria-hidden="true"
                   style="width: 50px;height: 50px;margin: auto">
                <use xlink:href="#icon-tips"></use>
              </svg>
            </div>
          </a-card>
          <a-card class="mt-0 p-0">
            <div class="border-bottom p-5">
              <p class="mb-1">委托单位:</p>
              <p class="color-black mb-0"> {{ bid.purchaserUnit }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="color-black mb-0">需求调查</p>
            </div>
            <div v-if="bid.signEndFlag === '1'" class="border-bottom p-5">
              <p class="mb-1">报名截止日期:</p>
              <p class="color-black mb-0"> {{ formatDate(bid.signUpEnd) }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">项目联系人:</p>
              <p class="color-black mb-0"> {{ bid.projectConcat }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">联系电话:</p>
              <p class="color-black mb-0"> {{ bid.projectConcatTel }} </p>
            </div>
          </a-card>
          <template v-if="bid.signUpState === 0">
            <a-button v-if="announce.onlineSign && announce.onlineSign === '0'" class="mt-4" size="large"
                      block>
              无需报名
            </a-button>
            <a-button v-else class="mt-4" type="primary" size="large" @click="signPermission" block>我要报名
            </a-button>
          </template>
          <template v-else-if="bid.signUpState === 1">
            <a-button class="mt-4" size="large" block>报名已截止</a-button>
          </template>
          <template v-else-if="bid.signUpState === -1">
            <a-button class="mt-4" size="large" block>未开始报名</a-button>
          </template>
        </a-col>
      </a-row>
    </div>
    <CommonFooter/>
  </div>
</template>

<script>
import CommonHeader from '../common/CommonHeader'
import CommonFooter from '../common/CommonFooter'
import UploadSelector from '@/components/selector/UploadSelector'
import moment from "moment";

export default {
  components: {
    CommonHeader,
    CommonFooter,
    UploadSelector
  },
  created() {
    this.initDetails(this.id)
  },
  watch: {},
  data() {
    return {
      data: [],
      id: this.$route.query.id,
      announceId: this.$route.query.id,
      announce: '',
      announceList: [],
      bid: '',
      isSign: false
    }
  },
  methods: {
    initDetails(announceId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getDetails/' + announceId).then(function (res) {
        if (res.code == 200) {
          console.log(res.result)
          that.announce = res.result
          that.initCard(that.announce.projectId)
          that.isSignUp(that.announce.projectId)
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    initCard(projectId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getSimpleBid/' + projectId + "/4").then(function (res) {
        if (res.code == 200) {
          that.bid = res.result
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    isSignUp(projectId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/isSignUp/' + projectId).then(function (res) {
        that.isSign = res
      })
    },
    formatDate(value) {
      if (!value) {
        return "未设置"
      }
      value = value.replace(new RegExp(/-/gm), "/")
      value = moment(new Date(value)).format("YYYY/MM/DD HH:mm")
      return value
    },
    onSwitch(announceId) {
      this.reloadDetails(announceId)
    },
    reloadDetails(announceId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getDetails/' + announceId).then(function (res) {
        if (res.code == 200) {
          that.announce = res.result
          that.initList(announceId)
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    sign() {
      this.$router.push({path: '/DemandSignIndex?id=' + this.bid.id})
    },
    showConfirm(value) {
      let that = this
      this.$confirm({
        title: "提示",
        content: value,
        okText: '立即认证',
        cancelText: '知道了',
        onOk() {
          that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
            that.$router.push({path: '/enterprise/LegalCertificationIndex'});
          });
        },
        onCancel() {
        }
      });
    },
    signPermission() {
      let that = this
      that.$http.get('/api/1/demandSign/demandSignPermission.json?xmid=' + that.bid.id).then(function (data) {
        if (data.code === 100) {
          that.$error({
            title: '提示',
            content: data.msg,
            okText: '确定',
            onOk() {

            }
          })
        } else if (data.code === 300) {
          that.showConfirm(data.msg)
        } else if (data.code === 200) {
          that.sign()
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.text-header {
  text-align: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 24px;
  font-size: 18px;
}

.text-header span {
  flex: 1;
}

.p_text_bg {
  border: 1px dashed #ccc;
  padding: 20px;
}

/deep/ .announce-content p {
  line-height: 30px;
}

/deep/ .announce-content ul {
  list-style: none;
}

/deep/ .p-0 .ant-card-body {
  padding: 0;
}

/deep/ .ant-tabs-nav .ant-tabs-tab {
  font-size: 20px;
  font-weight: bold;
}

/deep/ .ant-tabs-bar {
  margin-bottom: 0;
  border-bottom: 3px solid #e6e6e6;
}

/deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
  background: #fff;
}

.titleAnnounce {
  border-left: 3px solid #2F7FE3;
  padding-left: 16px;
  color: #333;
  font-size: 20px;
}

.border-bottom .p-5 {
  font-size: 14px;
}
</style>
